import { supabase } from './supabaseClient';

async function request(path, body, signal) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const headers = { Authorization: `Bearer ${session?.access_token || ''}` };
    if (body) headers['Content-Type'] = 'application/json';
    const response = await fetch(`/api/design/candidates${path}`, {
      method: body ? 'POST' : 'GET', headers, signal,
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const messages = {
        401: 'برای بررسی پیشنهادها دوباره وارد حساب شوید.',
        403: 'اجازهٔ بررسی پیشنهادها را ندارید.',
        429: 'درخواست‌های بررسی پیشنهادها زیاد است؛ یک دقیقه صبر کنید.',
      };
      return { error: messages[response.status] || data.error || 'بارگذاری پیشنهادها ناموفق بود؛ دوباره تلاش کنید.',
        code: data.code, status: response.status, retryable: response.status >= 500 };
    }
    return data;
  } catch (error) {
    if (error.name === 'AbortError') return { aborted: true };
    return { error: 'ارتباط برقرار نشد؛ اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.', retryable: true };
  }
}

export function candidatesInBbox(bounds, countOnly = false, signal) {
  const query = new URLSearchParams({ ...bounds, countOnly: String(countOnly) });
  return request(`?${query}`, null, signal);
}
export function acceptCandidate(id) { return request(`/${encodeURIComponent(id)}/accept`, {}); }
export function rejectCandidate(id, reason) { return request(`/${encodeURIComponent(id)}/reject`, { reason }); }
